import getBackendBaseUrl from "./apiBaseUrl";

const API_URL = getBackendBaseUrl();

export default API_URL;
